import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  pl: {
    translation: {
      // Navigation
      nav: {
        home: 'Strona główna',
        park: 'Park',
        activities: 'Aktywności',
        classes: 'Zajęcia',
        birthdays: 'Urodziny',
        physio: 'Fizjoterapia',
        prices: 'Terminy i ceny',
        passes: 'Karnety',
        camps: 'Obozy',
        faq: 'FAQ',
        contact: 'Kontakt',
        book: 'Rezerwuj',
        login: 'Zaloguj',
        register: 'Rejestracja',
        account: 'Moje konto',
        logout: 'Wyloguj',
        language: 'Język'
      },
      // Hero
      hero: {
        title: 'Tutaj zaczyna się progres',
        subtitle: 'Kryty skatepark dla tych, którzy chcą więcej',
        cta: 'Zarezerwuj sesję',
        explore: 'Odkryj park'
      },
      // Home sections
      home: {
        featuredTitle: 'Odkryj AvePark',
        featuredSubtitle: 'Wszystko czego potrzebujesz w jednym miejscu',
        newsTitle: 'Aktualności',
        newsSubtitle: 'Co nowego w AvePark',
        viewAll: 'Zobacz wszystkie',
        moreTitle: 'AvePark to nie tylko skatepark',
        moreSubtitle: 'Kompleksowa oferta dla całej rodziny'
      },
      // Cards
      cards: {
        classes: 'Zajęcia',
        classesDesc: 'Szkółki grupowe i indywidualne dla każdego poziomu',
        camps: 'Obozy',
        campsDesc: 'Letnie i zimowe obozy BMX oraz hulajnogowe',
        birthdays: 'Urodziny',
        birthdaysDesc: 'Niezapomniane urodziny w skateparku',
        restaurant: 'Restauracja',
        restaurantDesc: 'Smaczne jedzenie i napoje na miejscu',
        passes: 'Karnety',
        passesDesc: 'Oszczędzaj z karnetami ilościowymi i okresowymi',
        shop: 'Sklep',
        shopDesc: 'Profesjonalny sprzęt BMX i hulajnogowy'
      },
      // Booking
      booking: {
        title: 'Rezerwacja',
        step1: 'Dyscyplina',
        step2: 'Typ zajęć',
        step3: 'Dzień',
        step4: 'Godzina',
        step5: 'Podsumowanie',
        selectDiscipline: 'Wybierz dyscyplinę',
        selectType: 'Wybierz typ zajęć',
        selectDay: 'Wybierz dzień',
        selectTime: 'Wybierz godzinę',
        summary: 'Podsumowanie rezerwacji',
        spotsAvailable: 'Wolnych miejsc',
        price: 'Cena',
        promoCode: 'Kod rabatowy',
        apply: 'Zastosuj',
        usePass: 'Użyj karnetu',
        selectPerson: 'Wybierz osobę',
        confirm: 'Potwierdź rezerwację',
        payNow: 'Zapłać teraz',
        back: 'Wstecz',
        next: 'Dalej'
      },
      // Auth
      auth: {
        login: 'Logowanie',
        register: 'Rejestracja',
        email: 'Email',
        password: 'Hasło',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        phone: 'Numer telefonu',
        birthDate: 'Data urodzenia',
        gender: 'Płeć',
        male: 'Mężczyzna',
        female: 'Kobieta',
        termsOfService: 'Akceptuję Regulamin Serwisu',
        skateparkRules: 'Akceptuję Regulamin Skateparku',
        privacyPolicy: 'Akceptuję Politykę Prywatności',
        marketing: 'Zgoda na komunikację marketingową',
        requiredConsent: '(wymagane)',
        optionalConsent: '(opcjonalne)',
        minorAlert: {
          title: 'WYMAGANE OŚWIADCZENIE RODZICA / OPIEKUNA PRAWNEGO',
          description: 'Osoby niepełnoletnie muszą posiadać podpisane oświadczenie rodzica lub opiekuna prawnego.',
          downloadBtn: 'Pobierz oświadczenie'
        },
        loginBtn: 'Zaloguj się',
        registerBtn: 'Zarejestruj się',
        googleLogin: 'Zaloguj przez Google',
        noAccount: 'Nie masz konta?',
        hasAccount: 'Masz już konto?',
        step1Title: 'Dane konta',
        step2Title: 'Dodaj jeżdżących',
        addSubaccount: 'Dodaj osobę',
        skip: 'Pomiń',
        acceptAllRequired: 'Musisz zaakceptować wymagane zgody'
      },
      // Account
      account: {
        title: 'Moje konto',
        profile: 'Profil',
        subaccounts: 'Zarejestrowani użytkownicy',
        bookings: 'Rezerwacje',
        passes: 'Karnety',
        points: 'Punkty',
        addSubaccount: 'Dodaj osobę',
        activated: 'Aktywowane',
        activeBookings: 'Aktywne rezerwacje',
        activePasses: 'Aktywne karnety',
        mainAccountBadge: 'Konto główne',
        showCard: 'Pokaż kartę',
        cardNumber: 'Nr karty',
        noPeopleAdded: 'Nie dodano jeszcze żadnych osób',
        subaccountActive: 'Aktywne',
        subaccountInactive: 'Nieaktywne',
        unknownUser: 'Nieznany użytkownik'
      },
      // Passes
      passes: {
        title: 'Karnety',
        quantity: 'Ilościowe',
        period: 'Okresowe',
        season: 'Sezonowe',
        entries: 'wejść',
        validDays: 'dni ważności',
        buyForMe: 'Kup dla siebie',
        buyAsGift: 'Kup jako prezent',
        recipientEmail: 'Email odbiorcy',
        purchase: 'Kup karnet'
      },
      // Pricing
      pricing: {
        title: 'Terminy i ceny',
        sessions: 'Wejście na sesje',
        extras: 'Atrakcje dodatkowe',
        rentals: 'Wypożyczalnia',
        withReservation: 'z rezerwacją online',
        withoutReservation: 'bez rezerwacji',
        perHour: 'za godzinę',
        perDay: 'za dzień'
      },
      // Contact
      contact: {
        title: 'Kontakt',
        address: 'Adres',
        phone: 'Telefon',
        email: 'Email',
        hours: 'Godziny otwarcia',
        weekday: 'Poniedziałek - Piątek',
        weekend: 'Sobota - Niedziela',
        howToGet: 'Jak do nas dojechać',
        byCar: 'Samochodem',
        byTransit: 'Komunikacją miejską',
        rental: 'Wynajem skateparku',
        documents: 'Dokumenty'
      },
      // FAQ
      faq: {
        title: 'Często zadawane pytania'
      },
      // Park
      park: {
        title: 'Nasz park',
        description: 'Profesjonalny skatepark na światowym poziomie',
        sections: 'Sekcje parku'
      },
      // Activities
      activities: {
        title: 'Aktywności',
        classesTitle: 'Zajęcia',
        instructors: 'Nasi instruktorzy',
        gallery: 'Galeria'
      },
      // Common
      common: {
        readMore: 'Czytaj więcej',
        learnMore: 'Dowiedz się więcej',
        bookNow: 'Zarezerwuj',
        loading: 'Ładowanie...',
        error: 'Wystąpił błąd',
        success: 'Sukces',
        cancel: 'Anuluj',
        save: 'Zapisz',
        edit: 'Edytuj',
        delete: 'Usuń',
        close: 'Zamknij',
        pln: 'zł'
      },
      // Footer
      footer: {
        rights: 'Wszelkie prawa zastrzeżone',
        privacy: 'Polityka prywatności',
        terms: 'Regulamin'
      }
    }
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: 'Home',
        park: 'Park',
        activities: 'Activities',
        classes: 'Classes',
        birthdays: 'Birthdays',
        physio: 'Physiotherapy',
        prices: 'Prices & Schedule',
        passes: 'Passes',
        camps: 'Camps',
        faq: 'FAQ',
        contact: 'Contact',
        book: 'Book Now',
        login: 'Login',
        register: 'Register',
        account: 'My Account',
        logout: 'Logout',
        language: 'Language'
      },
      // Hero
      hero: {
        title: 'Next Generation Skatepark',
        subtitle: 'BMX • Scooter • Skateboard • Rollerblades',
        cta: 'Book a Session',
        explore: 'Explore Park'
      },
      // Home sections
      home: {
        featuredTitle: 'Discover AvePark',
        featuredSubtitle: 'Everything you need in one place',
        newsTitle: 'News',
        newsSubtitle: "What's new at AvePark",
        viewAll: 'View All',
        moreTitle: 'AvePark is more than a skatepark',
        moreSubtitle: 'Complete offer for the whole family'
      },
      // Cards
      cards: {
        classes: 'Classes',
        classesDesc: 'Group and individual lessons for all levels',
        camps: 'Camps',
        campsDesc: 'Summer and winter BMX and scooter camps',
        birthdays: 'Birthdays',
        birthdaysDesc: 'Unforgettable birthdays at the skatepark',
        restaurant: 'Restaurant',
        restaurantDesc: 'Delicious food and drinks on site',
        passes: 'Passes',
        passesDesc: 'Save with quantity and period passes',
        shop: 'Shop',
        shopDesc: 'Professional BMX and scooter equipment'
      },
      // Booking
      booking: {
        title: 'Booking',
        step1: 'Discipline',
        step2: 'Class Type',
        step3: 'Day',
        step4: 'Time',
        step5: 'Summary',
        selectDiscipline: 'Select discipline',
        selectType: 'Select class type',
        selectDay: 'Select day',
        selectTime: 'Select time',
        summary: 'Booking summary',
        spotsAvailable: 'Spots available',
        price: 'Price',
        promoCode: 'Promo code',
        apply: 'Apply',
        usePass: 'Use pass',
        selectPerson: 'Select person',
        confirm: 'Confirm booking',
        payNow: 'Pay now',
        back: 'Back',
        next: 'Next'
      },
      // Auth
      auth: {
        login: 'Login',
        register: 'Register',
        email: 'Email',
        password: 'Password',
        firstName: 'First Name',
        lastName: 'Last Name',
        phone: 'Phone Number',
        birthDate: 'Birth Date',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        termsOfService: 'I accept Terms of Service',
        skateparkRules: 'I accept Skatepark Rules',
        privacyPolicy: 'I accept Privacy Policy',
        marketing: 'I agree to marketing communications',
        requiredConsent: '(required)',
        optionalConsent: '(optional)',
        minorAlert: {
          title: 'PARENT / LEGAL GUARDIAN STATEMENT REQUIRED',
          description: 'Minors must have a signed statement from a parent or legal guardian.',
          downloadBtn: 'Download statement'
        },
        loginBtn: 'Log In',
        registerBtn: 'Sign Up',
        googleLogin: 'Login with Google',
        noAccount: "Don't have an account?",
        hasAccount: 'Already have an account?',
        step1Title: 'Account Details',
        step2Title: 'Add Riders',
        addSubaccount: 'Add person',
        skip: 'Skip',
        acceptAllRequired: 'You must accept all required consents'
      },
      // Account
      account: {
        title: 'My Account',
        profile: 'Profile',
        subaccounts: 'Registered Users',
        bookings: 'Bookings',
        passes: 'Passes',
        points: 'Points',
        addSubaccount: 'Add person',
        activated: 'Activated',
        activeBookings: 'Active bookings',
        activePasses: 'Active passes',
        mainAccountBadge: 'Main account',
        showCard: 'Show card',
        cardNumber: 'Card No.',
        noPeopleAdded: 'No people added yet',
        subaccountActive: 'Active',
        subaccountInactive: 'Inactive',
        unknownUser: 'Unknown user'
      },
      // Passes
      passes: {
        title: 'Passes',
        quantity: 'Quantity',
        period: 'Period',
        season: 'Seasonal',
        entries: 'entries',
        validDays: 'days valid',
        buyForMe: 'Buy for myself',
        buyAsGift: 'Buy as gift',
        recipientEmail: 'Recipient email',
        purchase: 'Purchase pass'
      },
      // Pricing
      pricing: {
        title: 'Prices & Schedule',
        sessions: 'Session Entry',
        extras: 'Additional Activities',
        rentals: 'Equipment Rental',
        withReservation: 'with online reservation',
        withoutReservation: 'without reservation',
        perHour: 'per hour',
        perDay: 'per day'
      },
      // Contact
      contact: {
        title: 'Contact',
        address: 'Address',
        phone: 'Phone',
        email: 'Email',
        hours: 'Opening Hours',
        weekday: 'Monday - Friday',
        weekend: 'Saturday - Sunday',
        howToGet: 'How to get here',
        byCar: 'By car',
        byTransit: 'By public transit',
        rental: 'Skatepark rental',
        documents: 'Documents'
      },
      // FAQ
      faq: {
        title: 'Frequently Asked Questions'
      },
      // Park
      park: {
        title: 'Our Park',
        description: 'World-class professional skatepark',
        sections: 'Park Sections'
      },
      // Activities
      activities: {
        title: 'Activities',
        classesTitle: 'Classes',
        instructors: 'Our Instructors',
        gallery: 'Gallery'
      },
      // Common
      common: {
        readMore: 'Read more',
        learnMore: 'Learn more',
        bookNow: 'Book now',
        loading: 'Loading...',
        error: 'An error occurred',
        success: 'Success',
        cancel: 'Cancel',
        save: 'Save',
        edit: 'Edit',
        delete: 'Delete',
        close: 'Close',
        pln: 'PLN'
      },
      // Footer
      footer: {
        rights: 'All rights reserved',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service'
      }
    }
  },
  // Ukrainian - fallback to Polish for missing translations
  uk: {
    translation: {
      nav: {
        home: 'Головна',
        park: 'Парк',
        activities: 'Активності',
        classes: 'Заняття',
        birthdays: 'Дні народження',
        physio: 'Фізіотерапія',
        prices: 'Ціни',
        passes: 'Абонементи',
        camps: 'Табори',
        faq: 'FAQ',
        contact: 'Контакт',
        book: 'Бронювати',
        login: 'Увійти',
        register: 'Реєстрація',
        account: 'Мій обліковий запис',
        logout: 'Вийти',
        language: 'Мова'
      }
    }
  },
  // German - fallback to Polish/English for missing translations
  de: {
    translation: {
      nav: {
        home: 'Startseite',
        park: 'Park',
        activities: 'Aktivitäten',
        classes: 'Kurse',
        birthdays: 'Geburtstage',
        physio: 'Physiotherapie',
        prices: 'Preise',
        passes: 'Karten',
        camps: 'Camps',
        faq: 'FAQ',
        contact: 'Kontakt',
        book: 'Buchen',
        login: 'Anmelden',
        register: 'Registrieren',
        account: 'Mein Konto',
        logout: 'Abmelden',
        language: 'Sprache'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl',
    // Allow any language - languages without resources will use fallback
    // This enables dynamic languages added via admin panel
    supportedLngs: false, // Don't restrict languages
    nonExplicitSupportedLngs: true, // Accept any language
    // Don't load missing translations - just use fallback
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
